import { Component } from '@angular/core';

@Component({
  template: `<router-outlet></router-outlet>`,
  providers: []
})
export class NewsComponent  { }



// WEBPACK FOOTER //
// ./src/app/noticias/news.component.ts